(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
  typeof define === 'function' && define.amd ? define(['react'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global["dist/index"] = global["dist/index"] || {}, global["dist/index"].js = factory(global.React)));
})(this, (function (React) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

  function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') {
      return;
    }
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css_248z$1 = ".loader_overlay {\n  position: fixed !important;\n  z-index: 1050;\n  inset: 0;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.5);\n}";
  styleInject(css_248z$1);

  var Overlay = function (_a) {
      var children = _a.children;
      return (React__default["default"].createElement("div", { "data-testid": 'overlay', role: 'presentation', "aria-hidden": 'true', className: 'loader_overlay' }, children));
  };

  var css_248z = "/* Consolidation of frequently used colours throughout the repo */\n.loader_panel {\n  box-sizing: border-box;\n  max-width: 400px;\n  max-height: 154px;\n  height: 100%;\n  width: 100%;\n  min-height: 0rem !important;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #ffffff;\n  flex: 1 0 !important;\n  border-radius: 5px;\n  padding: 0rem 1rem 1rem 1rem !important;\n  margin: 0rem 2rem;\n}\n.loader_panel > .spinner {\n  box-sizing: border-box;\n  margin: 35px auto 25px auto;\n  border: 4px solid #fafafa;\n  border-top: 4px solid #00677f;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spinnerRotate 1s linear infinite;\n}\n.loader_panel > p {\n  font-size: 1.125rem;\n  text-align: center;\n  font-family: \"AvenirLTStd-95-Black\", \"avenir_lt_roman\", sans-serif;\n  font-weight: normal;\n  line-height: 26px;\n  margin: 0rem !important;\n  color: #051d33 !important;\n}\n\n@keyframes spinnerRotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@media screen and (max-width: 450px) {\n  .loader_panel > .spinner {\n    margin: auto;\n  }\n}\n@media screen and (max-width: 300px) {\n  .loader_panel {\n    padding: 1rem !important;\n  }\n  .loader_panel > p {\n    line-height: 1;\n  }\n}";
  styleInject(css_248z);

  var LoaderPanel = function (_a) {
      var lang = _a.lang, message = _a.message;
      var displayedMessage = typeof message === 'string'
          ? message
          : lang.toLowerCase() === 'en'
              ? 'Loading, please wait.'
              : 'Actualisation en cours, veuillez patienter.';
      return (React__default["default"].createElement("div", { className: 'loader_panel' },
          React__default["default"].createElement("div", { className: 'spinner' }),
          React__default["default"].createElement("p", null, displayedMessage)));
  };

  var Loader = function (_a) {
      var _b, _c;
      var message = _a.message, lang = _a.lang;
      var convertedLang = (typeof lang === 'string'
          ? lang
          : typeof ((_b = window === null || window === void 0 ? void 0 : window.globalState) === null || _b === void 0 ? void 0 : _b.lang) === 'string'
              ? window.globalState.lang
              : typeof ((_c = window === null || window === void 0 ? void 0 : window.localStorage) === null || _c === void 0 ? void 0 : _c.getItem('lang')) === 'string'
                  ? window.localStorage.getItem('lang')
                  : 'en');
      return (React__default["default"].createElement(Overlay, null,
          React__default["default"].createElement(LoaderPanel, { message: message, lang: convertedLang })));
  };

  return Loader;

}));
